export default __webpack_public_path__ + "static/media/front_ins.28694c87.svg";